<template>
  <div class="audio-input" :class="{ 'is-active': recording }">
    <div class="audio-loading" v-if="recording">
      <div v-for="item in 6" :key="item"></div>
    </div>

    <span
      v-else
      class="audio-text"
      @touchstart.prevent="handleTouchstart"
      @touchend="handleTouchend"
    >
      按住 说话
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setUploadFile } from '@/database/index'

export default {
  data() {
    return {
      counter: 0,
      recording: false,
      mediaRecorder: null,
      chunks: [],
      startTimestamp: null,
      sendTime: 0,
      sendInterval: null
    }
  },
  computed: {
    ...mapState(['chatControl', 'sendControl'])
  },
  async mounted() {
    // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {}
    }

    // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
    // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = (constraints) => {
        // 首先，如果有getUserMedia的话，就获得它
        const getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia

        // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
        if (!getUserMedia) {
          return Promise.reject(
            new Error('getUserMedia is not implemented in this browser')
          )
        }

        // 否则，为老的navigator.getUserMedia方法包裹一个Promise
        return new Promise((resolve, reject) => {
          getUserMedia.call(navigator, constraints, resolve, reject)
        })
      }
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

      this.mediaRecorder = new MediaRecorder(stream)
      this.recorderEvents()
    } catch (error) {
      this.$emit('error', error)
    }
  },
  methods: {
    recorderEvents() {
      const { mediaRecorder } = this
      mediaRecorder.ondataavailable = (e) => {
        this.chunks.push(e.data)
      }

      mediaRecorder.onstop = async (e) => {
        this.recording = false
        const endTimestamp = Date.parse(new Date())
        const longTime = (endTimestamp - this.startTimestamp) / 1000
        if (longTime < 1) {
          this.$createToast({
            txt: '说话时间太短',
            type: 'warn'
          }).show()
          return
        }

        const type = {
          type: 'audio/mp3; codecs=opus'
        }
        const blob = new Blob(this.chunks, type)
        this.chunks = []

        const file = new File([blob], 'audio.mp3', type)
        const reslut = await setUploadFile({ file })
        this.chatControl.addInfoByAudio(`audio(${longTime})[${reslut.src}]`)
      }
    },

    handleTouchstart() {
      if (this.mediaRecorder.state === 'inactive') {
        this.startTimestamp = Date.parse(new Date())
        this.mediaRecorder.start()
        this.recording = true
        this.sendControl.entering('focus')
      }
    },

    handleTouchend() {
      if (this.mediaRecorder.state === 'recording') {
        if (this.recording) {
          this.mediaRecorder.stop()
        }
        this.sendControl.entering('blur')
      }
    }
  }
}
</script>

<style lang="stylus">
.audio-input {
  position: relative;
  height: 30px;
  line-height: 30px;
  margin: 5px 10px 5px 0;
  text-align: center;
  border-radius: 25px;
  position: relative;

  &.is-active {
    background: #e8e8e8;
  }
}

.audio-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.audio-text {
  font-size: 14px;
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 25px;

  &:after {
    content: '';
    height: 150%;
    width: 10px;
    background: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    opacity: 0.6;
    filter: blur(6px);
    animation: move 2s infinite ease-out;
  }
}

@keyframes move {
  0% {
    transform: translate(-200px, -10px) rotate(15deg);
  }

  100% {
    transform: translate(200px, 10px) rotate(15deg);
  }
}

.audio-loading {
  display: inline-block;
  position: relative;
  height: 100%;
  width: 30%;

  > div {
    display: inline-block;
    position: absolute;
    left: 0;
    width: 7%;
    background: #193a79;
    border-radius: 25px;
    animation: audio-loading 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
}

for num in 1 .. 8 {
  .audio-loading div:nth-child({num}) {
    left: 15% * (num - 1);
    animation-delay: -0.12s * (5 - num);
  }
}

@keyframes audio-loading {
  0% {
    top: 0px;
    height: 100%;
  }

  50%, 100% {
    top: 37.5%;
    height: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/audioInput.vue